<template>
  <div class="m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Locations</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addLocation"
        variant="primary"
        >New</b-button
      >
    </div>
    <grid
      ref="grid"
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
      @storesort="listeners.storeSort"
    ></grid>
    <b-modal
      centered
      ref="form-modal"
      :title="formId ? 'Edit Location' : 'Add Location'"
      header-bg-variant="primary"
      header-text-variant="white"
      @ok="submitLocation"
      no-close-on-backdrop
      size="lg"
      header-class="bg-purple"
    >
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button variant="secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
      <div class="location-form-container">
        <b-tabs v-model="activeTab">
          <b-tab title="Location Info">
            <div class="section-body">
              <square-image-cropper
                :image="fileChoosed"
                v-model="cropImage"
                @cropped="saveCroppedImage"
              />
              <b-row>
                <b-col>
                  <div class="d-flex flex-row align-items-end mb-2">
                    <div
                      class="picture-preview mr-2"
                      style="width: 220px; height: 180px;"
                    >
                      <img
                        :src="
                          form.logo
                            ? form.logo
                            : require(`../../assets/avatar-example.png`)
                        "
                      />
                    </div>
                    <b-form-group
                      :state="formErrors.logo.length == 0 ? null : false"
                      :invalid-feedback="formErrors.logo.join(', ')"
                    >
                      <input
                        ref="fileUpload"
                        @change="cropFile"
                        type="file"
                        accept="image/*"
                        hidden
                      />
                    </b-form-group>
                    <div class="d-flex flex-column ml-2">
                      <label
                        class="mb-0 text-primary fileUploadLb"
                        @click="chooseFile()"
                        ><i class="fa fa-upload m-1"></i>Choose file</label
                      >

                      <label
                        v-if="form.logo"
                        class="mb-0 text-red fileUploadLb"
                        @click="removePicture()"
                        ><i class="fa fa-trash m-1"></i>Remove file</label
                      >
                    </div>
                  </div>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Name"
                    :state="formErrors.name.length == 0 ? null : false"
                    :invalid-feedback="formErrors.name.join(', ')"
                  >
                    <template v-slot:label>
                      Name <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                      v-model="form.name"
                      trim
                      maxLength="100"
                      :state="formErrors.name.length == 0 ? null : false"
                    ></b-form-input>
                  </b-form-group>
                  <b-form-group
                    label="Timezone"
                    :state="
                      formErrors.selectedTimezone.length == 0 ? null : false
                    "
                    :invalid-feedback="formErrors.selectedTimezone.join(', ')"
                  >
                    <template v-slot:label>
                      Timezone <span class="text-danger">*</span>
                    </template>
                    <v-select
                      v-model="selectedTimezone"
                      :options="timeZoneOptions"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Email"
                    :state="formErrors.email.length == 0 ? null : false"
                    :invalid-feedback="formErrors.email.join(', ')"
                  >
                    <b-form-input
                      v-model="form.email"
                      trim
                      maxLength="255"
                      :state="formErrors.email.length == 0 ? null : false"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Phone Number"
                    :state="formErrors.phone.length == 0 ? null : false"
                    :invalid-feedback="formErrors.phone.join(', ')"
                  >
                    <phone-input
                      ref="phoneInput"
                      defaultCountry="US"
                      v-model="form.phone"
                      trim
                      :state="formErrors.phone.length == 0 ? null : false"
                    ></phone-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Tax ID"
                    :state="formErrors.taxId.length == 0 ? null : false"
                    :invalid-feedback="formErrors.taxId.join(', ')"
                  >
                    <template v-slot:label>
                      Tax ID <span class="text-danger">*</span>
                    </template>
                    <b-form-input
                      v-model="form.taxId"
                      trim
                      maxLength="100"
                      :state="formErrors.taxId.length == 0 ? null : false"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="NPI#"
                    :state="formErrors.npiNo.length == 0 ? null : false"
                    :invalid-feedback="formErrors.npiNo.join(', ')"
                  >
                    <template v-slot:label>
                      NPI#
                      <span
                        v-if="
                          systemSetting.pmpEnable ||
                            systemSetting.saisystemsEnabled
                        "
                        class="text-danger"
                        >*</span
                      >
                    </template>
                    <b-form-input
                      v-model="form.npiNo"
                      trim
                      maxLength="100"
                      :state="formErrors.npiNo.length == 0 ? null : false"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Fax"
                    :state="formErrors.fax.length == 0 ? null : false"
                    :invalid-feedback="formErrors.fax.join(', ')"
                  >
                    <phone-input
                      ref="faxInput"
                      defaultCountry="US"
                      v-model="form.fax"
                      trim
                      :state="formErrors.fax.length == 0 ? null : false"
                    ></phone-input>
                  </b-form-group>
                </b-col>
                <b-col> </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Address Line 1">
                    <b-form-input
                      v-model="form.addressLine1"
                      trim
                      maxLength="255"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Address Line 2">
                    <b-form-input
                      v-model="form.addressLine2"
                      trim
                      maxLength="255"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="City">
                    <b-form-input
                      v-model="form.city"
                      trim
                      maxLength="100"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="State">
                    <v-select
                      v-model="form.state"
                      trim
                      :options="states"
                    ></v-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group
                    label="Zipcode"
                    :state="formErrors.zipcode.length == 0 ? null : false"
                    :invalid-feedback="formErrors.zipcode.join(', ')"
                  >
                    <b-form-input
                      v-model="form.zipcode"
                      v-facade="'#####'"
                      trim
                      :state="formErrors.zipcode.length == 0 ? null : false"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col></b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Days of operation">
                    <week-days-picker v-model="weekDaysOfOperation" />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Hours of operation">
                    <b-row>
                      <b-col>
                        <b-form-group
                          :state="
                            formErrors.operationStarts.length == 0
                              ? null
                              : false
                          "
                          :invalid-feedback="
                            formErrors.operationStarts.join(', ')
                          "
                        >
                          <time-picker
                            v-model="form.operationStarts"
                            :beginTime="'00:00'"
                            :endTime="'23:00'"
                            :placeholder="'From'"
                          />
                        </b-form-group>
                      </b-col>
                      <b-col>
                        <b-form-group
                          :state="
                            formErrors.operationEnds.length == 0 ? null : false
                          "
                          :invalid-feedback="
                            formErrors.operationEnds.join(', ')
                          "
                        >
                          <time-picker
                            v-model="form.operationEnds"
                            :beginTime="beginTimeForEnd"
                            :endTime="'23:59'"
                            :placeholder="'To'"
                          />
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Forms & Documents">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group
                    label="Default Treatment Plan Form"
                    :state="
                      formErrors.treatmentPlanForm.length == 0 ? null : false
                    "
                    :invalid-feedback="formErrors.treatmentPlanForm.join(', ')"
                  >
                    <v-select
                      v-model="form.treatmentPlanForm"
                      :options="masterTreatmentForms"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group
                    label="Default Group Session Service"
                    :state="
                      formErrors.defaultService.length == 0 ? null : false
                    "
                    :invalid-feedback="formErrors.defaultService.join(', ')"
                  >
                    <v-select
                      v-model="form.defaultService"
                      :options="availableServices"
                    />
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Doctor Order Form">
                    <v-select
                      v-model="form.doctorOrderForm"
                      :options="doctorOrderForms"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Form groups available in this location">
                    <b-row>
                      <b-col
                        v-for="(renderFormGroupColumn,
                        renderFormGroupColumnIndex) in renderFormGroups"
                        :key="renderFormGroupColumnIndex"
                      >
                        <div
                          v-for="renderFormGroup in renderFormGroupColumn"
                          :key="renderFormGroup.id"
                          class="d-flex"
                        >
                          <div style="padding-top:2px;">
                            <vue-toggles
                              @click="toggleFormGroupAccess(renderFormGroup)"
                              :value="
                                form.formGroupAccess[renderFormGroup.id]
                                  ? true
                                  : false
                              "
                              height="18"
                              width="28"
                              checkedText=""
                              uncheckedText=""
                              checkedBg="#34C759"
                              uncheckedBg="#FF6161"
                            />
                          </div>
                          <span class="ml-2">{{ renderFormGroup.name }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Forms available in this location">
                    <b-row>
                      <b-col
                        v-for="(renderFormColumn,
                        renderFormColumnIndex) in renderForms"
                        :key="renderFormColumnIndex"
                      >
                        <div
                          v-for="renderForm in renderFormColumn"
                          :key="renderForm.id"
                          class="d-flex"
                        >
                          <div style="padding-top:2px;">
                            <vue-toggles
                              @click="toggleFormAccess(renderForm.id)"
                              :value="
                                form.formAccess[renderForm.id] ? true : false
                              "
                              height="18"
                              width="28"
                              checkedText=""
                              uncheckedText=""
                              checkedBg="#34C759"
                              uncheckedBg="#FF6161"
                            />
                          </div>
                          <span class="ml-2">{{ renderForm.name }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="User Access">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group label="Users with access to this location">
                    <b-row>
                      <b-col
                        v-for="(renderUserColumn,
                        renderUserColumnIndex) in renderUsers"
                        :key="renderUserColumnIndex"
                      >
                        <div
                          v-for="renderUser in renderUserColumn"
                          :key="renderUser.id"
                          class="d-flex"
                        >
                          <div style="padding-top:2px;">
                            <vue-toggles
                              @click="toggleUserAccess(renderUser.id)"
                              :value="
                                form.userAccess[renderUser.id] ? true : false
                              "
                              height="18"
                              width="28"
                              checkedText=""
                              uncheckedText=""
                              checkedBg="#34C759"
                              uncheckedBg="#FF6161"
                            />
                          </div>
                          <span class="ml-2">
                            {{ `${formatUser(renderUser)}`.trim() }}
                          </span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Levels of Care">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group
                    label="Levels of care available on this location"
                  >
                    <b-row>
                      <b-col
                        v-for="(renderLevelOfCareColumn,
                        renderLevelOfCareColumnIndex) in renderLevelOfCares"
                        :key="renderLevelOfCareColumnIndex"
                      >
                        <div
                          v-for="renderLevelOfCare in renderLevelOfCareColumn"
                          :key="renderLevelOfCare.id"
                          class="d-flex"
                        >
                          <div style="padding-top:2px;">
                            <vue-toggles
                              @click="
                                toggleLevelOfCareAccess(renderLevelOfCare.id)
                              "
                              :value="
                                form.levelOfCareAccess[renderLevelOfCare.id]
                                  ? true
                                  : false
                              "
                              height="18"
                              width="28"
                              checkedText=""
                              uncheckedText=""
                              checkedBg="#34C759"
                              uncheckedBg="#FF6161"
                            />
                          </div>
                          <span class="ml-2">{{ renderLevelOfCare.name }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Vital Signs">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group label="Vital signs available on this location">
                    <b-row>
                      <b-col
                        v-for="(renderVitalSignColumn,
                        renderVitalSignColumnIndex) in renderVitalSigns"
                        :key="renderVitalSignColumnIndex"
                      >
                        <div
                          v-for="renderVitalSign in renderVitalSignColumn"
                          :key="renderVitalSign.id"
                          class="d-flex"
                        >
                          <div style="padding-top:2px;">
                            <vue-toggles
                              @click="toggleVitalSignAccess(renderVitalSign.id)"
                              :value="
                                form.vitalSignAccess[renderVitalSign.id]
                                  ? true
                                  : false
                              "
                              height="18"
                              width="28"
                              checkedText=""
                              uncheckedText=""
                              checkedBg="#34C759"
                              uncheckedBg="#FF6161"
                            />
                          </div>
                          <span class="ml-2">{{ renderVitalSign.name }}</span>
                        </div>
                      </b-col>
                    </b-row>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Reminders">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group
                    style="margin-bottom:40px;"
                    label="Appointment Reminders"
                    :state="
                      formErrors.scheduleEventReminderHours.length == 0
                        ? null
                        : false
                    "
                    :invalid-feedback="
                      formErrors.scheduleEventReminderHours.join(', ')
                    "
                  >
                    <template v-slot:label>
                      <b>Appointment Reminders</b>
                    </template>
                    <div
                      style="font-size: 13px;"
                      class="d-flex align-items-center"
                    >
                      <span>Send reminder</span>
                      <b-form-input
                        size="sm"
                        v-model="form.scheduleEventReminderHours"
                        class="ml-2"
                        id="hours"
                        type="number"
                        @keypress="isDecimalOrNegative($event)"
                        min="1"
                        max="48"
                        style="width: 70px; height: 100%"
                      />
                      <span class="ml-2">
                        hours before appointment start date.
                      </span>
                    </div>
                  </b-form-group>
                  <b-form-group
                    style="margin-bottom:40px;"
                    label="Document Reminders"
                    :state="
                      formErrors.pendingDocumentReminderDays.length == 0
                        ? null
                        : false
                    "
                    :invalid-feedback="
                      formErrors.pendingDocumentReminderDays.join(', ')
                    "
                  >
                    <template v-slot:label>
                      <b>Document Reminders</b>
                    </template>
                    <b-form-checkbox
                      style="font-size: 13px;"
                      v-model="form.pendingDocumentReminderEnable"
                      :value="true"
                      :unchecked-value="false"
                      ><span>
                        Enable pending document reminders.
                      </span>
                    </b-form-checkbox>
                    <div
                      style="font-size: 13px;"
                      class="d-flex align-items-center"
                      :class="
                        !form.pendingDocumentReminderEnable
                          ? 'color-custom-grey'
                          : ''
                      "
                    >
                      <span>
                        Send reminder when a document has been in Draft or
                        Pending status for more than
                      </span>
                      <b-form-input
                        :disabled="!form.pendingDocumentReminderEnable"
                        size="sm"
                        v-model="form.pendingDocumentReminderDays"
                        @keypress="isDecimalOrNegative($event)"
                        class="ml-2"
                        id="hours"
                        type="number"
                        min="1"
                        style="width: 70px; height: 100%"
                      />
                      <span class="ml-2">
                        days.
                      </span>
                    </div>
                  </b-form-group>
                  <b-form-group
                    style="margin-bottom:40px;"
                    label="Not Given Medication Reminders"
                    :state="
                      formErrors.notGivenMedicationReminderMinutes.length == 0
                        ? null
                        : false
                    "
                    :invalid-feedback="
                      formErrors.notGivenMedicationReminderMinutes.join(', ')
                    "
                  >
                    <template v-slot:label>
                      <b>Not Given Medication Reminders</b>
                    </template>
                    <div
                      style="font-size: 13px;"
                      class="d-flex align-items-center"
                    >
                      <span>
                        Send reminder when a medication has not been given for
                        more than
                      </span>
                      <b-form-input
                        size="sm"
                        v-model="form.notGivenMedicationReminderMinutes"
                        @keypress="isDecimalOrNegative($event)"
                        class="ml-2"
                        id="minutes"
                        type="number"
                        min="1"
                        max="48"
                        style="width: 70px; height: 100%"
                      />
                      <span class="ml-2">
                        minutes.
                      </span>
                    </div>
                  </b-form-group>
                  <b-form-group
                    style="margin-bottom:40px;"
                    label="Treatment Plan due to date reminder"
                    :state="
                      formErrors.treatmentPlanDueDateReminderDays == 0
                        ? false
                        : null
                    "
                    :invalid-feedback="
                      formErrors.treatmentPlanDueDateReminderDays.join(', ')
                    "
                  >
                    <template v-slot:label>
                      <b>Treatment Plan due to date reminder</b>
                    </template>
                    <div
                      style="font-size: 13px;"
                      class="d-flex align-items-center"
                    >
                      <span>
                        Send reminders for treatment plans due within
                      </span>
                      <b-form-input
                        size="sm"
                        :state="
                          form.treatmentPlanDueDateReminderDays == 0
                            ? false
                            : null
                        "
                        v-model="form.treatmentPlanDueDateReminderDays"
                        @keypress="isDecimalOrNegative($event)"
                        class="ml-2"
                        id="days"
                        type="number"
                        min="1"
                        max="48"
                        style="width: 70px; height: 100%"
                      />
                      <span class="ml-2">
                        days.
                      </span>
                    </div>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
          <b-tab title="Additional Settings">
            <div class="section-body">
              <b-row>
                <b-col>
                  <b-form-group>
                    <b-form-checkbox
                      v-model="form.marsMilitaryTimes"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Show times on MARS in military format
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import locationServer from "../../server/location";
import { mapActions, mapState, mapMutations } from "vuex";
import {
  validateEmail,
  validatePhoneNumber,
  validateRequired,
  validateZipcode,
  validateIsNumber,
  validateNumberLessEqualThan,
  validateNumberGreaterEqualThan,
  validateLengthEqualThan
} from "../../helpers/validation";
import timeZoneServer from "../../server/timeZone";
import SquareImageCropper from "../controls/SquareImageCropper.vue";
import WeekDaysPicker from "../controls/WeekDaysPicker.vue";
import TimePicker from "../controls/TimePicker.vue";
import PhoneInput from "../controls/PhoneInput.vue";
import moment from "moment";
import { chunkColumns } from "../../helpers/general";
import userServer from "../../server/user";
import serviceServer from "../../server/service";

export default {
  name: "LocationCrud",
  components: {
    Grid,
    SquareImageCropper,
    WeekDaysPicker,
    TimePicker,
    PhoneInput
  },
  data() {
    const self = this;
    return {
      list: [],
      formId: null,
      filter: {
        orderBy: "name",
        orderByDescending: false
      },
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length === 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.filter.orderBy = field;
            self.filter.orderByDescending = !ascending;
            self.getLocations();
          }
        }
      },
      form: {
        logo: "",
        name: "",
        taxId: "",
        npiNo: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: null,
        zipcode: "",
        phone: "",
        email: "",
        fax: "",
        timeZoneDisplayName: null,
        timeZoneBaseUtcOffset: null,
        timeZoneId: null,
        operationStarts: null,
        operationEnds: null,
        operatesOnSunday: false,
        operatesOnMonday: false,
        operatesOnTuesday: false,
        operatesOnWednesday: false,
        operatesOnThursday: false,
        operatesOnFriday: false,
        operatesOnSaturday: false,
        formAccess: {},
        formGroupAccess: {},
        userAccess: {},
        levelOfCareAccess: {},
        vitalSignAccess: {},
        treatmentPlanForm: null,
        defaultService: null,
        doctorOrderForm: null,
        scheduleEventReminderHours: null,
        pendingDocumentReminderEnable: false,
        pendingDocumentReminderDays: null,
        marsMilitaryTimes: false,
        notGivenMedicationReminderMinutes: null,
        treatmentPlanDueDateReminderDays: null
      },
      formErrors: {
        name: [],
        logo: [],
        taxId: [],
        zipcode: [],
        phone: [],
        email: [],
        fax: [],
        npiNo: [],
        selectedTimezone: [],
        operationStarts: [],
        operationEnds: [],
        scheduleEventReminderHours: [],
        pendingDocumentReminderDays: [],
        notGivenMedicationReminderMinutes: [],
        treatmentPlanDueDateReminderDays: [],
        treatmentPlanForm: [],
        defaultService: []
      },
      timeZones: [],
      fileChoosed: null,
      cropImage: false,
      activeTab: 0,
      users: [],
      services: []
    };
  },
  async mounted() {
    this.getLocations();
    this.getUsers();
    this.getServices();
    this.fetchVitalSigns();
    this.fetchLevelsOfCare();
    this.fetchStates();
    this.fetchTimeZones();
    this.fetchFormBuilderForms({ category: "main" });
    this.fetchFormBuilderForms({ category: "masterTreatmentPlan" });
    this.fetchFormBuilderForms({ category: "groupSession" });
    this.fetchFormBuilderForms({ category: "doctorOrder" });
    this.fetchFormGroups();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    ...mapActions("client", [
      "fetchStates",
      "fetchVitalSigns",
      "fetchLevelsOfCare"
    ]),
    ...mapActions("formGroup", ["fetchFormGroups"]),
    ...mapMutations("layout", ["setSelectedLocationObj"]),
    isDecimalOrNegative(e) {
      const keyPressed = e.key;
      if (keyPressed === "." || keyPressed === "-") {
        e.preventDefault();
      }
    },
    async removePicture() {
      this.$dialog
        .confirm(
          {
            title: "Are you sure you want to delete this picture?"
          },
          {
            view: "confirm-delete"
          }
        )
        .then(() => {
          this.fileChoosed = null;
          this.form.logo = "";
        });
    },
    async fetchTimeZones() {
      this.timeZones = await timeZoneServer.query();
    },
    async getLocations() {
      this.list = await locationServer.query({
        orderBy: this.filter.orderBy,
        orderByDescending: this.filter.orderByDescending
      });
    },
    async getUsers() {
      this.users = await userServer.queryImproved();
    },
    async getServices() {
      this.services = await serviceServer.query({
        type: "Service"
      });
    },
    validateSubmitLocation() {
      let withoutErrors = true;

      this.formErrors.name = [];
      if (!validateRequired(this.form.name)) {
        this.formErrors.name.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.taxId = [];
      if (!validateRequired(this.form.taxId)) {
        this.formErrors.taxId.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.zipcode = [];
      if (this.form.zipcode && !validateZipcode(this.form.zipcode)) {
        this.formErrors.zipcode.push("This field must have a valid zipcode");
        withoutErrors = false;
      }
      this.formErrors.phone = [];
      if (
        this.form.phone.trim().length >
          this.activePhoneCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.phone)
      ) {
        this.formErrors.phone.push("Invalid phone number");
        withoutErrors = false;
      }

      this.formErrors.email = [];
      if (this.form.email && !validateEmail(this.form.email)) {
        this.formErrors.email.push("This field must have a valid email");
        withoutErrors = false;
      }

      this.formErrors.fax = [];
      if (
        this.form.fax.trim().length >
          this.activeFaxCountry.dialCode.length + 1 &&
        !validatePhoneNumber(this.form.fax)
      ) {
        this.formErrors.fax.push("Invalid phone number");
        withoutErrors = false;
      }
      if (
        this.systemSetting.pmpEnable ||
        this.systemSetting.saisystemsEnabled
      ) {
        this.formErrors.npiNo = [];
        if (!validateRequired(this.form.npiNo)) {
          this.formErrors.npiNo.push("This field is required");
          withoutErrors = false;
        } else if (!validateIsNumber(this.form.npiNo)) {
          this.formErrors.npiNo.push("This field must be a number");
          withoutErrors = false;
        } else if (!validateLengthEqualThan(this.form.npiNo.toString(), 10)) {
          this.formErrors.npiNo.push("This field must have 10 digits");
          withoutErrors = false;
        }
      }

      this.formErrors.selectedTimezone = [];
      if (!validateRequired(this.selectedTimezone)) {
        this.formErrors.selectedTimezone.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.operationStarts = [];
      if (this.form.operationEnds && !this.form.operationStarts) {
        this.formErrors.operationStarts.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.operationEnds = [];
      if (this.form.operationStarts && !this.form.operationEnds) {
        this.formErrors.operationEnds.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.scheduleEventReminderHours = [];
      if (
        !validateNumberLessEqualThan(this.form.scheduleEventReminderHours, 48)
      ) {
        this.formErrors.scheduleEventReminderHours.push("Max value of 48");
        withoutErrors = false;
      }

      this.formErrors.notGivenMedicationReminderMinutes = [];
      if (
        !validateNumberGreaterEqualThan(
          this.form.notGivenMedicationReminderMinutes,
          0
        )
      ) {
        this.formErrors.notGivenMedicationReminderMinutes.push(
          "Min value of 0"
        );
        withoutErrors = false;
      }

      this.formErrors.treatmentPlanDueDateReminderDays = [];
      if (this.form.treatmentPlanDueDateReminderDays == 0) {
        this.formErrors.treatmentPlanDueDateReminderDays.push(
          "Value can't be 0"
        );
        withoutErrors = false;
      }

      this.formErrors.treatmentPlanForm = [];
      if (!validateRequired(this.form.treatmentPlanForm)) {
        this.formErrors.treatmentPlanForm.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.defaultService = [];
      if (!validateRequired(this.form.defaultService)) {
        this.formErrors.defaultService.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitLocation(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateSubmitLocation();
      if (result) {
        const formData = {
          name: this.form.name,
          taxId: this.form.taxId,
          npiNo: this.form.npiNo,
          addressLine1: this.form.addressLine1,
          addressLine2: this.form.addressLine2,
          city: this.form.city,
          stateId: this.form.state ? this.form.state.value : null,
          zipcode: this.form.zipcode,
          phoneNumber:
            this.form.phone.trim().length >
            this.activePhoneCountry.dialCode.length + 1
              ? this.form.phone
              : "",
          email: this.form.email,
          fax:
            this.form.fax.trim().length >
            this.activeFaxCountry.dialCode.length + 1
              ? this.form.fax
              : "",
          timeZoneDisplayName: this.form.timeZoneDisplayName,
          timeZoneBaseUtcOffset: this.form.timeZoneBaseUtcOffset,
          timeZoneId: this.form.timeZoneId,
          operatesOnMonday: this.form.operatesOnMonday,
          operatesOnTuesday: this.form.operatesOnTuesday,
          operatesOnWednesday: this.form.operatesOnWednesday,
          operatesOnThursday: this.form.operatesOnThursday,
          operatesOnFriday: this.form.operatesOnFriday,
          operatesOnSaturday: this.form.operatesOnSaturday,
          operatesOnSunday: this.form.operatesOnSunday,
          operationStarts: this.form.operationStarts,
          operationEnds: this.form.operationEnds,
          logo: this.form.logo,
          formIds: Object.keys(this.form.formAccess).filter(
            formId => this.form.formAccess[formId]
          ),
          formGroupIds: Object.keys(this.form.formGroupAccess).filter(
            formGroupId => this.form.formGroupAccess[formGroupId]
          ),
          userIds: Object.keys(this.form.userAccess).filter(
            userId => this.form.userAccess[userId]
          ),
          vitalSignIds: Object.keys(this.form.vitalSignAccess).filter(
            vitalSignId => this.form.vitalSignAccess[vitalSignId]
          ),
          serviceIds: Object.keys(this.form.levelOfCareAccess).filter(
            levelOfCareId => this.form.levelOfCareAccess[levelOfCareId]
          ),
          treatmentPlanFormId: this.form.treatmentPlanForm?.value,
          defaultServiceId: this.form.defaultService?.value,
          doctorOrderFormId: this.form.doctorOrderForm?.value,
          marsMilitaryTimes: this.form.marsMilitaryTimes,
          scheduleEventReminderHours: +this.form.scheduleEventReminderHours,
          pendingDocumentReminderEnable: this.form
            .pendingDocumentReminderEnable,
          pendingDocumentReminderDays: +this.form.pendingDocumentReminderDays,
          notGivenMedicationReminderMinutes: +this.form
            .notGivenMedicationReminderMinutes,
          treatmentPlanDueDateReminderDays: +this.form
            .treatmentPlanDueDateReminderDays
        };
        if (this.formId) {
          const selectedLocationObj = await locationServer.update(
            this.formId,
            formData
          );
          if (this.formId == this.selectedLocation) {
            this.setSelectedLocationObj(selectedLocationObj);
          }
        } else {
          await locationServer.create(formData);
        }
        this.getLocations();
        this.showAlertSuccess();
        this.$refs["form-modal"].hide();
      } else {
        if (!this.hasErrorsInRemindersTab) {
          this.activeTab = 1;
          if (this.hasErrorsInLocationInfoTab) this.activeTab = 0;
        } else this.activeTab = 5;
      }
    },
    addLocation() {
      this.clearError();
      this.formId = null;
      this.form = {
        logo: "",
        name: "",
        taxId: "",
        npiNo: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: null,
        zipcode: "",
        phone: "",
        email: "",
        fax: "",
        timeZoneDisplayName: null,
        timeZoneBaseUtcOffset: null,
        timeZoneId: null,
        operationStarts: null,
        operationEnds: null,
        operatesOnSunday: false,
        operatesOnMonday: false,
        operatesOnTuesday: false,
        operatesOnWednesday: false,
        operatesOnThursday: false,
        operatesOnFriday: false,
        operatesOnSaturday: false,
        formAccess: {},
        formGroupAccess: {},
        userAccess: {},
        levelOfCareAccess: {},
        vitalSignAccess: {},
        treatmentPlanForm: null,
        defaultService: null,
        doctorOrderForm: null,
        scheduleEventReminderHours: 48,
        pendingDocumentReminderEnable: false,
        pendingDocumentReminderDays: 3,
        marsMilitaryTimes: false,
        notGivenMedicationReminderMinutes: 10,
        treatmentPlanDueDateReminderDays: 2
      };

      this.$refs["form-modal"].show();
    },
    clearError() {
      (this.formErrors = {
        name: [],
        logo: [],
        taxId: [],
        zipcode: [],
        phone: [],
        email: [],
        fax: [],
        npiNo: [],
        selectedTimezone: [],
        operationStarts: [],
        operationEnds: [],
        scheduleEventReminderHours: [],
        pendingDocumentReminderDays: [],
        notGivenMedicationReminderMinutes: [],
        treatmentPlanDueDateReminderDays: [],
        treatmentPlanForm: [],
        defaultService: []
      }),
        this.$refs["form-modal"].show();
    },
    saveCroppedImage(croppedBase64) {
      this.form.logo = croppedBase64;
    },
    chooseFile() {
      this.$refs.fileUpload.value = null;
      this.$refs.fileUpload.click();
    },
    validateCropFile(file) {
      let withoutErrors = true;

      const fileSize = (file.size / 1024 / 1024).toFixed(4);

      this.avatarErrors = [];
      if (fileSize > 20) {
        this.avatarErrors.push("Image max size 20 mb");
        withoutErrors = false;
      }

      if (!file.type.includes("image/")) {
        this.avatarErrors.push("Only image file supported");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    cropFile() {
      const file = this.$refs.fileUpload.files[0];
      const result = this.validateCropFile(file);
      if (result) {
        this.fileChoosed = file;
        this.cropImage = true;
      }
    },
    toggleFormAccess(formId) {
      this.form.formAccess = {
        ...this.form.formAccess,
        [formId]: !this.form.formAccess[formId]
      };

      if (!this.form.formAccess[formId]) {
        this.renderFormGroups.map(item => {
          item.forEach(data => {
            let formGroupId = data.id;
            data.formIds.forEach(frmId => {
              if (frmId == formId) {
                this.form.formGroupAccess = {
                  ...this.form.formGroupAccess,
                  [formGroupId]: false
                };
              }
            });
          });
        });
      }
    },
    toggleFormGroupAccess(formGroup) {
      this.form.formGroupAccess = {
        ...this.form.formGroupAccess,
        [formGroup.id]: !this.form.formGroupAccess[formGroup.id]
      };
      formGroup.formIds.forEach(formId => {
        this.form.formAccess = {
          ...this.form.formAccess,
          [formId]: this.form.formGroupAccess[formGroup.id]
        };
      });
    },
    toggleUserAccess(userId) {
      this.form.userAccess = {
        ...this.form.userAccess,
        [userId]: !this.form.userAccess[userId]
      };
    },
    toggleVitalSignAccess(vitalSignId) {
      this.form.vitalSignAccess = {
        ...this.form.vitalSignAccess,
        [vitalSignId]: !this.form.vitalSignAccess[vitalSignId]
      };
    },
    toggleLevelOfCareAccess(levelOfCareId) {
      this.form.levelOfCareAccess = {
        ...this.form.levelOfCareAccess,
        [levelOfCareId]: !this.form.levelOfCareAccess[levelOfCareId]
      };
    }
  },
  computed: {
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.id
        })),
      levelOfCares: state => state.levelsOfCare,
      vitalSigns: state => state.vitalSigns
    }),
    ...mapState("formBuilder", {
      allForms: state => state.list
    }),
    ...mapState("formGroup", {
      formGroups: state => state.list
    }),
    ...mapState("layout", {
      selectedLocation: state => state.selectedLocation,
      selectedLocationObj: state => state.selectedLocationObj,
      systemSetting: state => state.systemSetting
    }),
    forms() {
      return this.allForms["main"];
    },
    masterTreatmentForms() {
      return this.allForms["masterTreatmentPlan"].map(form => ({
        value: form.id,
        label: form.name
      }));
    },
    availableServices() {
      return this.services.map(service => ({
        value: service.id,
        label: service.name
      }));
    },
    doctorOrderForms() {
      return this.allForms["doctorOrder"].map(form => ({
        value: form.id,
        label: form.name
      }));
    },
    renderForms() {
      const forms = this.forms;
      forms.sort((a, b) => a.name.localeCompare(b.name));
      return chunkColumns(forms, 3);
    },
    renderFormGroups() {
      const formGroups = this.formGroups;
      formGroups.sort((a, b) => a.name.localeCompare(b.name));
      return chunkColumns(formGroups, 3);
    },
    renderUsers() {
      const users = this.users;
      users.sort((a, b) => a.lastName.localeCompare(b.lastName));
      return chunkColumns(users, 3);
    },
    renderVitalSigns() {
      return chunkColumns(this.vitalSigns, 3);
    },
    renderLevelOfCares() {
      return chunkColumns(this.levelOfCares, 3);
    },
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      const self = this;
      let columns = [
        {
          text: "Name",
          field: "name",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => record.data.name,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Tax ID",
          field: "taxId",
          type: "template",
          flex: 1,
          editor: false,
          template: ({ record }) => record.data.taxId,
          sortable() {
            return self.filter.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src="${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.clearError();
                this.formId = record.id;
                const form = await locationServer.get(this.formId);
                const formIds = {};
                for (let index = 0; index < form.formIds.length; index++) {
                  const formId = form.formIds[index];
                  formIds[formId] = true;
                }

                const formGroupIds = {};
                for (let index = 0; index < form.formGroupIds.length; index++) {
                  const formGroupId = form.formGroupIds[index];
                  formGroupIds[formGroupId] = true;
                }

                const userIds = {};
                for (let index = 0; index < form.userIds.length; index++) {
                  const userId = form.userIds[index];
                  userIds[userId] = true;
                }
                const levelOfCareIds = {};
                for (let index = 0; index < form.serviceIds.length; index++) {
                  const levelOfCareId = form.serviceIds[index];
                  levelOfCareIds[levelOfCareId] = true;
                }

                const vitalSignIds = {};
                for (let index = 0; index < form.vitalSignIds.length; index++) {
                  const vitalSignId = form.vitalSignIds[index];
                  vitalSignIds[vitalSignId] = true;
                }
                this.form = {
                  logo: form.logo,
                  name: form.name,
                  taxId: form.taxId,
                  npiNo: form.npiNo,
                  addressLine1: form.addressLine1,
                  addressLine2: form.addressLine2,
                  city: form.city,
                  state: form.state
                    ? {
                        value: form.state.id,
                        label: form.state.name
                      }
                    : null,
                  zipcode: form.zipcode,
                  phone: form.phoneNumber,
                  email: form.email,
                  fax: form.fax,
                  timeZoneDisplayName: form.timeZoneDisplayName,
                  timeZoneBaseUtcOffset: form.timeZoneBaseUtcOffset,
                  timeZoneId: form.timeZoneId,
                  operationStarts: form.operationStarts,
                  operationEnds: form.operationEnds,
                  operatesOnSunday: form.operatesOnSunday,
                  operatesOnMonday: form.operatesOnMonday,
                  operatesOnTuesday: form.operatesOnTuesday,
                  operatesOnWednesday: form.operatesOnWednesday,
                  operatesOnThursday: form.operatesOnThursday,
                  operatesOnFriday: form.operatesOnFriday,
                  operatesOnSaturday: form.operatesOnSaturday,
                  formAccess: formIds,
                  formGroupAccess: formGroupIds,
                  userAccess: userIds,
                  levelOfCareAccess: levelOfCareIds,
                  vitalSignAccess: vitalSignIds,
                  scheduleEventReminderHours: form.scheduleEventReminderHours,
                  pendingDocumentReminderEnable:
                    form.pendingDocumentReminderEnable,
                  pendingDocumentReminderDays: form.pendingDocumentReminderDays,
                  treatmentPlanDueDateReminderDays:
                    form.treatmentPlanDueDateReminderDays,
                  marsMilitaryTimes: form.marsMilitaryTimes,
                  notGivenMedicationReminderMinutes:
                    form.notGivenMedicationReminderMinutes,
                  treatmentPlanForm: form.treatmentPlanFormId
                    ? this.masterTreatmentForms.find(
                        f => f.value == form.treatmentPlanFormId
                      )
                    : null,
                  defaultService: form.defaultServiceId
                    ? this.availableServices.find(
                        f => f.value == form.defaultServiceId
                      )
                    : null,
                  doctorOrderForm: form.doctorOrderFormId
                    ? this.doctorOrderForms.find(
                        f => f.value == form.doctorOrderFormId
                      )
                    : null
                };
                this.$refs["form-modal"].show();
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src=	"${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await locationServer.delete(record.id);
                    this.getLocations();
                    this.showAlertSuccess();
                    this.dispatchListener({
                      listener: "fetchDocumentMenus",
                      param: "all"
                    });
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    },
    timeZoneOptions() {
      return this.timeZones.map(timeZone => ({
        ...timeZone,
        value: timeZone.id,
        label: timeZone.displayName
      }));
    },
    selectedTimezone: {
      get() {
        return this.timeZoneOptions.find(
          tz => tz.value === this.form.timeZoneId
        );
      },
      set(newValue) {
        if (newValue) {
          this.form.timeZoneDisplayName = newValue.displayName;
          this.form.timeZoneBaseUtcOffset = newValue.baseUtcOffset;
          this.form.timeZoneId = newValue.id;
        } else {
          this.form.timeZoneDisplayName = null;
          this.form.timeZoneBaseUtcOffset = null;
          this.form.timeZoneId = null;
        }
      }
    },
    weekDaysOfOperation: {
      get() {
        return [
          ...(this.form.operatesOnSunday ? ["0"] : []),
          ...(this.form.operatesOnMonday ? ["1"] : []),
          ...(this.form.operatesOnTuesday ? ["2"] : []),
          ...(this.form.operatesOnWednesday ? ["3"] : []),
          ...(this.form.operatesOnThursday ? ["4"] : []),
          ...(this.form.operatesOnFriday ? ["5"] : []),
          ...(this.form.operatesOnSaturday ? ["6"] : [])
        ];
      },
      set(newValue) {
        this.form.operatesOnSunday = newValue.includes("0");
        this.form.operatesOnMonday = newValue.includes("1");
        this.form.operatesOnTuesday = newValue.includes("2");
        this.form.operatesOnWednesday = newValue.includes("3");
        this.form.operatesOnThursday = newValue.includes("4");
        this.form.operatesOnFriday = newValue.includes("5");
        this.form.operatesOnSaturday = newValue.includes("6");
      }
    },
    beginTimeForEnd() {
      return moment(this.form.operationStarts, "HH:mm").add(1, "minutes");
    },
    activePhoneCountry() {
      return this.$refs.phoneInput.$refs.telInput.activeCountry;
    },
    activeFaxCountry() {
      return this.$refs.faxInput.$refs.telInput.activeCountry;
    },
    hasErrorsInRemindersTab() {
      return (
        this.formErrors.scheduleEventReminderHours.length > 0 ||
        this.formErrors.pendingDocumentReminderDays.length > 0 ||
        this.formErrors.notGivenMedicationReminderMinutes.length > 0 ||
        this.formErrors.treatmentPlanDueDateReminderDays.length > 0
      );
    },
    hasErrorsInLocationInfoTab() {
      return (
        this.formErrors.name.length > 0 ||
        this.formErrors.taxId.length > 0 ||
        this.formErrors.zipcode.length > 0 ||
        this.formErrors.phone.length > 0 ||
        this.formErrors.email.length > 0 ||
        this.formErrors.fax.length > 0 ||
        this.formErrors.npiNo.length > 0 ||
        this.formErrors.selectedTimezone.length > 0 ||
        this.formErrors.operationStarts.length > 0 ||
        this.formErrors.operationEnds.length > 0
      );
    }
  }
};
</script>

<style scoped>
.form-item:hover {
  cursor: pointer;
}
.forms-list {
  max-height: 200px;
  overflow-y: auto;
}
.location-form-container .section-body {
  height: calc(100vh - 315px);
  overflow-y: auto;
  overflow-x: hidden;
}
.location-form-container >>> .nav-tabs {
  background-color: #f5f8fc;
  border-bottom: none;
  padding: 0 15px;
}
.location-form-container >>> .nav-tabs .nav-link {
  color: #777;
  font-weight: bold;
  background: none;
  border: none;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-radius: 2px;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
}
.location-form-container >>> .nav-tabs .nav-link.active {
  color: #4044e6;
  border-bottom-color: #4044e6;
}
.location-form-container >>> .tab-content {
  padding: 1rem;
}
</style>
